import { NgModule } from '@angular/core';
import { ImagePreloadDirective } from './image-preload/image-preload';

@NgModule({
	declarations: [ImagePreloadDirective],
	imports: [],
	exports: [ImagePreloadDirective]
})
export class DirectivesModule {}
